import './Subtitle.scss';

function Subtitle({text}) {
    return (
        <div className='container'>
             <div className='subtitle'>
                {text}
             </div>
        </div>
    )
}
export default Subtitle;